import './toolbar.sass'

import React from 'react';

import TrackViewOptionsSwitch from 'controls/track-view-options-switch/TrackViewOptionsSwitch';
import TrackRangeSlider from 'controls/track-range-slider/TrackRangeSlider';
import ShowChartButton from 'components/track-templates/show-chart-button/ShowChartButton';
import CreateButton from 'components/track-templates/create-button/CreateButton';

export default class Toolbar extends React.Component {
  render() {
    return (
      <nav className="track-templates-toolbar navbar navbar-default">
        <div className="container-fluid">
          <div className="navbar-header">
            <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-navbar-collapse" aria-expanded="false">
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            </button>
          </div>

          <div className="collapse navbar-collapse" id="bs-navbar-collapse">
            <TrackViewOptionsSwitch
              view={ 'templates' }
              trackId={ this.props.trackId }
            />
            <TrackRangeSlider
              trackId={ this.props.trackId }
            />

            <ShowChartButton
              trackId={ this.props.trackId }
            />

            <CreateButton
              trackId={ this.props.trackId }
            />
          </div>
        </div>
      </nav>
    );
  }
}
